module.exports = __webpack_public_path__ + "static/media/icon_schedule_phone.04c75c1b.svg";